module.exports = __webpack_public_path__ + "static/media/galerija_2017 (43).72869678.jpg";